"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _spinner = _interopRequireDefault(require("./spinner.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledSpinner = _styledComponents.default.svg.withConfig({
  displayName: "Spinner__StyledSpinner",
  componentId: "he4b9o-0"
})(["", " ", " @keyframes rotate{100%{transform:rotate(360deg);}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0;}50%{stroke-dasharray:90,150;stroke-dashoffset:-35;}100%{stroke-dasharray:90,150;stroke-dashoffset:-124;}}"], function (_ref) {
  var theme = _ref.theme,
      width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return (0, _styledComponents.css)(["width:", ";height:", ";& .path{stroke:", ";stroke-linecap:round;}"], width, height, theme.colors[color] || theme.colors.primary);
}, function (_ref2) {
  var animationOn = _ref2.animationOn,
      animationDuration = _ref2.animationDuration;
  return animationOn && (0, _styledComponents.css)(["animation:rotate ", " linear infinite;& .path{animation:dash 1.5s ease-in-out infinite;}"], animationDuration);
});

var Spinner = function Spinner(props) {
  var show = props.show,
      theme = props.theme,
      width = props.width,
      height = props.height,
      color = props.color,
      animationDuration = props.animationDuration,
      strokeWidth = props.strokeWidth,
      customProperties = props.customProperties;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      animationOn = _useState2[0],
      setAnimationOn = _useState2[1];

  (0, _react.useEffect)(function () {
    setAnimationOn(true);
  }, []);

  var getMain = function getMain() {
    return show && /*#__PURE__*/_react.default.createElement(StyledSpinner, (0, _extends2.default)({
      animationOn: animationOn,
      theme: themeContext,
      viewBox: "0 0 50 50",
      animationDuration: animationDuration,
      height: height,
      width: width,
      color: color
    }, customProperties), /*#__PURE__*/_react.default.createElement("circle", {
      className: "path",
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none",
      strokeWidth: strokeWidth
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Spinner.propTypes = _spinner.default.PropTypes;
Spinner.defaultProps = _spinner.default.DefaultProps;
var _default = Spinner;
exports.default = _default;